import Icon, {iconTypes} from "../../../common/components/Icon.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";
import { Tab, TabList, TabPanel, Tabs } from "../../../common/components/Tabs.jsx";

import BarCodeScanner from "../BarCodeScanner.jsx";
import FilterComponent from "../order/FilterComponent.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import ProductView from "./ProductView.jsx";
import PropTypes from "prop-types";
import React from "react";
import TextField from "../../../common/components/TextField.jsx";
import { hasCamera } from "../../util/camera.js";
import { makePropertyValue } from "../../../common/util/changeUtils.jsx";
import {scssVariables} from "../../../common/util/config.jsx";
import {withRouter} from "react-router-dom";

class ProductDisplayCard extends React.PureComponent {
    constructor(props){
        super(props);

        this.onClickViewList = this.onClickViewList.bind(this);
        this.onClickViewItem = this.onClickViewItem.bind(this);
        this.swallowOnClick = this.swallowOnClick.bind(this);

        this.onTabAllClicked = this.onTabAllClicked.bind(this);
        this.onTabNewClicked = this.onTabNewClicked.bind(this);
        this.onTabPurchasedBeforeClicked = this.onTabPurchasedBeforeClicked.bind(this);

        this.calculateInternalPanelHeight = this.calculateInternalPanelHeight.bind(this);

        this.onClickScan = this.onClickScan.bind(this);
        this.onBarcodeFound = this.onBarcodeFound.bind(this);
        this.onBarcodeCancel = this.onBarcodeCancel.bind(this);
        
        this.state = {
            hasCamera: false,
            scanning: false,
            tabIndex: 0,
        };
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        hasCamera().then(exists => this.setState({
            hasCamera: exists
        }));
    }

    onClickViewList(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setOrderProductView("list");
    }

    onClickViewItem(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setOrderProductView("item");
    }

    onTabAllClicked(){
        const path = this.props.location.pathname;
        //replace only whats after the last / with the new path
        this.props.history.replace(`${path.substr(0, path.lastIndexOf("/"))}/all`);
        this.props.editQueryFilter({
            OnlyCampaigns: false,
            OnlyNews: false,
            ReturnTobacco: false,
            OnlyLastSold: false,
            searchString: ""
        });
        this.setState({
            tabIndex: 0
        });
    }

    onTabNewClicked(){
        const path = this.props.location.pathname;
        //replace only whats after the last / with the new path
        this.props.history.replace(`${path.substr(0, path.lastIndexOf("/"))}/new`);
        this.props.editQueryFilter({
            OnlyCampaigns: false,
            OnlyNews: true,
            ReturnTobacco: false,
            OnlyLastSold: false,
            searchString: ""
        });
        this.setState({
            tabIndex: 1
        });
    }
    onTabPurchasedBeforeClicked(){
        const path = this.props.location.pathname;
        //replace only whats after the last / with the new path
        this.props.history.replace(`${path.substr(0, path.lastIndexOf("/"))}/purchased`);
        this.props.editQueryFilter({
            OnlyCampaigns: false,
            OnlyNews: false,
            ReturnTobacco: false,
            OnlyLastSold: true,
            searchString: ""
        });
        this.setState({
            tabIndex: 2
        });
    }

    onClickScan(event) {
        event.stopPropagation();
        event.preventDefault();

        this.onTabAllClicked();

        this.setState({
            scanning: true
        });
    }

    onBarcodeFound(result) {
        this.props.editQueryFilter(makePropertyValue("searchString", result), this.props.productQuery.filter);
        this.setState({
            scanning: false
        });
    }

    onBarcodeCancel() {
        this.setState({
            scanning: false
        });
    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;
        //remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        //if on xs device remove height of second menu
        if( this.props.deviceType==="xs" ) {
            tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }
        return tabPanelHeight;
    }

    render(){
        const {
            deviceType,
            activeOrder,
            localization,
            productView,
            height,
            width,
            productQuery,
            loadMoreSearchResaults,
            addRemoveProductToTemporaryOrder,
            editQueryFilter,
            currentView,
            setModal,
            setDropDown,
            countingNode
        } = this.props;
        const tabPanelHeight = this.calculateInternalPanelHeight();

        return (
            <div className={"card-default"} style={{display: "flex", flexDirection:"column", height:`${height}px`, width:`${width}px`}}>
                {deviceType==="xs" && (
                    <SubMenu border={true}>
                        <SubMenuItem iconType={iconTypes.search} roundCornerTopLeft={true} dropDownStyle={{width:`${width}px`}} setDropDown={setDropDown} dropDownChildren={(
                            <div className="search-wrapper" style={{flexDirection:"column", height:"55px"}} onClick={this.swallowOnClick}>
                                <div className="search-field">
                                    <TextField className="search-container" placeholder={localization.text("order","searchForProducts")} iconType={iconTypes.search} isValid={true} source={{searchString: ""}} property="searchString" onEdit={editQueryFilter} usingSubmit={true}/>
                                </div>
                            </div>
                        )} />
                        <SubMenuItem iconType={iconTypes.filter} dropDownStyle={{width:`${width-60}px`, overflow:"unset"}} setDropDown={setDropDown} dropDownChildren={(
                            <FilterComponent localization={localization} productQuery={productQuery} onEdit={editQueryFilter} setDropDown={setDropDown}/>
                        )}/>
                        {this.state.hasCamera && (
                            <SubMenuItem onClick={this.onClickScan}>
                                <Icon type={iconTypes.scan} className="menu-icon"/>
                            </SubMenuItem>
                        )}
                        <SubMenuItem side="right" roundCornerTopRight={true} onClick={this.onClickViewItem}>
                            <Icon type={iconTypes.viewItem}  opacity={productView.view==="item"?1.0:0.5} className="menu-icon"/>
                        </SubMenuItem>
                        <SubMenuItem side="right" onClick={this.onClickViewList}>
                            <Icon type={iconTypes.viewList} opacity={productView.view==="list"?1.0:0.5} className="menu-icon"/>
                        </SubMenuItem>
                    </SubMenu>
                )}
                <Tabs roundCorner={deviceType!=="xs"} startTabId={currentView} selectIndex={this.state.tabIndex}>
                    <TabList roundCorner={deviceType!=="xs"}>
                        <Tab id="all" label={localization.text("order","allProducts",{count:1234})} onClick={this.onTabAllClicked}/>
                        <Tab id="new" label={localization.text("order","newProducts",{count:12})} onClick={this.onTabNewClicked}/>
                        <Tab id="purchased" label={localization.text("order","purchasedBefore",{count:1234})} onClick={this.onTabPurchasedBeforeClicked}/>
                        {deviceType!=="xs" && (
                            <SubMenu border={true} style={{flex:"0 0 122px"}}>
                                <SubMenuItem side="right" roundCornerTopRight={true} onClick={this.onClickViewItem}>
                                    <Icon type={iconTypes.viewItem} opacity={productView.view==="item"?1.0:0.5} className="menu-icon"/>
                                </SubMenuItem>
                                <SubMenuItem side="right" onClick={this.onClickViewList}>
                                    <Icon type={iconTypes.viewList} opacity={productView.view==="list"?1.0:0.5} className="menu-icon"/>
                                </SubMenuItem>
                            </SubMenu>
                        )}
                    </TabList>
                    <TabPanel>
                        <ProductView
                            activeOrder={activeOrder}
                            localization={localization}
                            view={productView.view}
                            height={tabPanelHeight}
                            list={productQuery.resaults}
                            isLoading={productQuery.isLoading}
                            loadMoreProducts={loadMoreSearchResaults}
                            deviceType={deviceType}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            setModal={setModal}
                            countingNode={countingNode}
                            editQueryFilter={editQueryFilter}        

                        />
                    </TabPanel>
                    <TabPanel>
                        <ProductView
                            activeOrder={activeOrder}
                            localization={localization}
                            view={productView.view}
                            height={tabPanelHeight}
                            list={productQuery.resaults}
                            isLoading={productQuery.isLoading}
                            loadMoreProducts={loadMoreSearchResaults}
                            deviceType={deviceType}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            setModal={setModal}
                            countingNode={countingNode}
                            editQueryFilter={editQueryFilter} 
                        />
                    </TabPanel>
                    <TabPanel>
                        <ProductView
                            activeOrder={activeOrder}
                            localization={localization}
                            view={productView.view}
                            height={tabPanelHeight}
                            list={productQuery.resaults}
                            isLoading={productQuery.isLoading}
                            loadMoreProducts={loadMoreSearchResaults}
                            deviceType={deviceType}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            setModal={setModal}
                            countingNode={countingNode}
                            editQueryFilter={editQueryFilter} 
                        />
                    </TabPanel>
                    <TabPanel>
                        <ProductView
                            activeOrder={activeOrder}
                            localization={localization}
                            view={productView.view}
                            height={tabPanelHeight}
                            list={productQuery.resaults}
                            isLoading={productQuery.isLoading}
                            loadMoreProducts={loadMoreSearchResaults}
                            deviceType={deviceType}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            setModal={setModal}
                            countingNode={countingNode}
                            editQueryFilter={editQueryFilter} 
                        />
                    </TabPanel>
                </Tabs>
                {this.state.scanning && <BarCodeScanner onBarcodeFound={this.onBarcodeFound} onCancel={this.onBarcodeCancel}/>}
            </div>
        );
    }
}

ProductDisplayCard.propTypes = {
    deviceType: PropTypes.string.isRequired,
    activeOrder: PropTypes.object.isRequired,
    localization: Localization.propTypes.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchResaults: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    countingNode: PropTypes.node.isRequired,
    //
    currentView: PropTypes.string,
};

ProductDisplayCard.defaultProps = {
    currentView: "all",
};
export default withRouter(ProductDisplayCard);